import type { Role } from '@repo/api-gw-sdk';

export const buildRolesMap = (roles: Role[], selectedRole?: Role) =>
  Object.fromEntries(
    [...(selectedRole ? [selectedRole] : []), ...roles].map((role) => [
      role.id,
      role,
    ])
  );
